<template>
  <div class="item-standart"
       @click="itemClick">
    <div class="avatar">
      <child-avatar :child="child"
                    size="small"
                    icon="IconBlock"
                    icon-color="#fff"
                    icon-background-color="#ea1643"
                    :show-status="false" />
    </div>
    <div class="content">
      <div class="description with-info">
        <div class="title">
          {{ $t("blocked", { categories }) }}
        </div>

        <block-warn-info />
      </div>

      <a :href="item.details.url" class="one-liner">
        {{ urlTitle }}
      </a>

      <div class="details">
        <feed-item-details :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
  import ItemBase from './ItemBase.vue'
  import BlockWarnInfo from './BlockWarnInfo.vue'
  import getCategories from '@/services/categories.js'
  import analytics from '@/services/analytics.js'

  import { getDomain } from '@/services/utils.js'

  export default {
    extends: ItemBase,

    props: {
      item: {
        required: true,
        type: Object
      }
    },

    components: {
      BlockWarnInfo
    },

    methods: {
      itemClick() {
        analytics.sendEvent('Pk_Block_Feed')
      },

      ...mapGetters('categories', {
        getCategoryById: 'getById'
      })
    },

    computed: {
      child() {
        return this.getChildById(this.item.user_id)
      },

      // showItem() {
      //   // It is possible that there is no URL
      //   return this.item.details.url && this.child
      // },

      categories() {
        return getCategories(
          this.item.details.category_ids,
          this.commonCategories,
          this.customCategories
        )
      },

      urlTitle() {
        return getDomain(this.item.details.url)
      },

      ...mapGetters('categories', {
        commonCategories: 'get',
        customCategories: 'getCustom'
      }),

      ...mapGetters('children', {
        getChildById: 'getById'
      })
    }
  }
</script>

<style lang="scss" scoped>
  .with-info {
    position: relative;
    padding-right: 30px;
  }
</style>
